import axios from "./api";
const headers =
  typeof window !== "undefined"
    ? {
        Authorization: `${localStorage.getItem("mimictoken") || localStorage.getItem("token")}`,
        "X-API-KEY": `${process.env.GATSBY_API_KEY}`,
      }
    : {};

export const urelids = async (data, callback) => {
  try {
    const urlParams = Object.keys(data)
      .map(function (k) {
        return encodeURIComponent(k) + "=" + encodeURIComponent(data[k]);
      })
      .join("&");
    const headers = { "Access-Control-Allow-Origin": "*" };
    const response = await axios({
      method: "get",
      headers: headers,
      url: `${process.env.GATSBY_ADMIN_URL}urelids.cfm?${urlParams}`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};
export const unsubscribe = async (data, callback) => {
  try {
    const urlParams = Object.keys(data)
      .map(function (k) {
        return encodeURIComponent(k) + "=" + encodeURIComponent(data[k]);
      })
      .join("&");
    const response = await axios({
      method: "get",
      headers: headers,
      url: `${process.env.GATSBY_ADMIN_URL}unsubscribe.cfm?${urlParams}`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};
export const getProfile = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}user/personalInfo`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};
export const register = async (data, callback) => {
  try {
    const headers = { "X-API-KEY": `${process.env.GATSBY_API_KEY}` };
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}register`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};
export const upcomingBids = async (callback) => {
  try {
    const headers = { "X-API-KEY": `${process.env.GATSBY_API_KEY}` };
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}upcomingBids`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const upcomingBidDropDown = async (callback) => {
  try {
    const headers = { "X-API-KEY": `${process.env.GATSBY_API_KEY}` };
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}upcomingBidDropDown`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const login = async (data, callback) => {
  try {
    const headers = { "X-API-KEY": `${process.env.GATSBY_API_KEY}` };
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}login`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getNotification = async (narrow = 1, callback, page = 1) => {
  try {
    if (!localStorage.getItem("token")) return callback({ error: true });

    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}notification?narrow=${narrow}&page=${page}`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const updateNotification = async (id, callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}viewNotification?id=${id}`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getCount = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}user/dashboardCount`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getEndingSoon = async (callback) => {
  try {
    const headers = { "X-API-KEY": `${process.env.GATSBY_API_KEY}` };
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}endingSoon`,
    });
    callback(response);
  } catch (e) {
    callback && callback(e);
  }
};

export const forgetPassword = async (data, callback) => {
  try {
    const headers = { "X-API-KEY": `${process.env.GATSBY_API_KEY}` };
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}requestReset`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const setPassword = async (data, callback) => {
  try {
    const headers = { "X-API-KEY": `${process.env.GATSBY_API_KEY}` };
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}setPassword`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const bookMark = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}bookmark`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const askQuestion = async (data) => {
  try {
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}askQuestion`,
    });
    return response;
  } catch (e) {
    return e;
  }
};

export const placeBid = async (data, callback) => {
  const headersPlaceBid =
    typeof window !== "undefined"
      ? {
          Authorization: `${localStorage.getItem("mimictoken") || localStorage.getItem("token")}`,
          "X-API-KEY": `${process.env.GATSBY_API_KEY}`,
        }
      : {};
  try {
    const response = await axios({
      method: "post",
      data,
      headers: headersPlaceBid,
      url: `${process.env.GATSBY_API_URL}placebid`,
    });
    callback(response);
  } catch (e) {
    callback(e.response);
  }
};

export const postListing = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}postListing`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const imageUpload = async (data, id, callback) => {
  try {
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}fileUpload/${id}`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};
export const imageDelete = async (id, callback) => {
  try {
    const response = await axios({
      method: "delete",
      headers,
      url: `${process.env.GATSBY_API_URL}deletePhoto/${id}`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};
export const markAsPrimary = async (id, data, callback) => {
  try {
    const response = await axios({
      method: "put",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}fileUpload/primaryPicture/${id}`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};
export const updatePictureCaption = async (id, data, callback) => {
  try {
    const response = await axios({
      method: "put",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}fileUpload/caption/${id}`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};
export const fileUpload = async (data, id, callback) => {
  try {
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}docUpload/${id}`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const privateFileUpload = async (data, id, callback) => {
  try {
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}docUploadPrivate/${id}`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const fileDelete = async (id, callback) => {
  try {
    const response = await axios({
      method: "delete",
      headers,
      url: `${process.env.GATSBY_API_URL}deleteDoc/${id}`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const lowerAskingPrice = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}update-asking-price`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const acceptOffer = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}accept-bid`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const checkMaxBid = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}selling/check-max-bid`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const addTask = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}selling/addTask`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const reactivateListing = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}reactivate-auction`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const counterOffer = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}counter-offer`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const auctionDetailReport = async (id, callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}report/auction-details?auction_id=${id}`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const organizationDetailReport = async (id, callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}report/organization-details?auction_id=${id}`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const teamDetailReport = async (id, callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}report/team-details?auction_id=${id}`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const activityDetailReport = async (id, callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}report/activity-details?auction_id=${id}`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const recoveryReport = async (id, token, callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url:
        id === 0
          ? `${process.env.GATSBY_API_URL}report/recovery-report`
          : `${process.env.GATSBY_API_URL}report/recovery-report?auction_id=${id}${
              token?.length > 0 ? `&token=${token}` : ""
            }`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const recoveryReportDetails = async (params, callback) => {
  try {
    const response = await axios({
      method: "get",
      headers:
        typeof window !== "undefined"
          ? {
              "X-API-KEY": `${process.env.GATSBY_API_KEY}`,
            }
          : {},
      url: `${process.env.GATSBY_API_URL}report/recovery-report?token=${params}`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const invoice = async (id, params = false, callback) => {
  try {
    const response = await axios({
      method: "get",
      params: params ? params : "",
      headers,
      url: id === 0 ? `${process.env.GATSBY_API_URL}invoice/list` : `${process.env.GATSBY_API_URL}invoice/detail/${id}`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const updatePipeLog = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}pipe-access-log`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const deleteVerificationDoc = async (data, callback) => {
  try {
    const response = await axios({
      method: "delete",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}register/delete-doc`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const checkToken = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers:
        typeof window !== "undefined"
          ? {
              Authorization: `${localStorage.getItem("mimictoken") || localStorage.getItem("token")}`,
              "X-API-KEY": `${process.env.GATSBY_API_KEY}`,
            }
          : {},
      url: `${process.env.GATSBY_API_URL}user/checkSession`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getStates = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}state`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getCountries = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}country`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getIndustries = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}industry`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getCategories = async (params, callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      params,
      url: `${process.env.GATSBY_API_URL}categoryListHome`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getRegions = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}regionsHome`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getManufacturers = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}manufacturers`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getTopManufacturers = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}topManufacturer`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const addToCart = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}aviation/aviationPart/cart`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getCart = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}aviation/aviationPart/cart`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const saveOrderRequest = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}aviation/aviationPart/orderRequest`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const updateCartItem = async (id, data, callback) => {
  try {
    const response = await axios({
      method: "PUT",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}aviation/aviationPart/cart/${id}`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getOrderRequest = async (params, callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}aviation/aviationPart/orderRequest`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const deleteCartItem = async (id, callback) => {
  try {
    const response = await axios({
      method: "delete",
      headers,
      url: `${process.env.GATSBY_API_URL}aviation/aviationPart/cart/${id}`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const signAgreement = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}listingAgreement/signAndSave`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const signMultipleAgreement = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}listingAgreement/multiple/signAndSave`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getAgreementList = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}listingAgreement/list`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getAuctionHistory = async (id, callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}user/myAllListingHistory?page=1`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const updateAuctionHistory = async (id, callback) => {
  try {
    const response = await axios({
      method: "post",
      headers,
      url: `${process.env.GATSBY_API_URL}user/myListingHistory/${id}`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const saverfqrequest = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}aviation/aviationPart/rfqRequest`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getRfqRequests = async (params, callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      params,
      url: `${process.env.GATSBY_API_URL}aviation/aviationPart/rfqRequest`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getProcurementRequests = async (params, callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      params,
      url: `${process.env.GATSBY_API_URL}aviation/aviationPart/procurementRequest`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const updateSellerReportPreferences = async (data, callback) => {
  try {
    const response = await axios({
      method: "put",
      headers,
      data,
      url: `${process.env.GATSBY_API_URL}update-send-report-email-frequency`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const shareMyBuyerList = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}broker/broker/shareListingWithBuyers`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const trackBuyer = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}broker/broker/track`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const buyerActivity = async (params, callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      params,
      url: `${process.env.GATSBY_API_URL}broker/broker/activity`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const speciesReport = async (id, callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}report/auction-species?auction_id=${id}`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getMyReferrals = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}broker/broker/buyer?keyword=&sort=buyerName&order=asc`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getSpecies = async (params, callback) => {
  try {
    const response = await axios({
      method: "get",
      params,
      headers,
      url: `${process.env.GATSBY_API_URL}report/arr/ei/species`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getSpeciesCategory = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}report/arr/ei/species/category`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getSellerReport = async (id, callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}report/arr/sellerReport/${id}`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const logOut = async (callback) => {
  try {
    const response = await axios({
      method: "post",
      headers,
      url: `${process.env.GATSBY_API_URL}logout`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const verifyQuantity = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}confirm-quantity`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const updateBuyerARR = async (data, callback) => {
  try {
    const response = await axios({
      method: "put",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}update-buyer-report-email-frequency`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const resubscribe = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}user/resubscribe`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getConversationList = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}askQuestion/list`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getConversation = async (id, callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}askQuestion/conversation/${id}`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getNewQuestionList = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}askQuestion/list`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const subscribe = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}subscribe`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const markAsRead = async (data, callback) => {
  try {
    const response = await axios({
      method: "put",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}askQuestion/markAsRead`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const unReadChatCount = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}askQuestion/unreadCount`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const updateKeyBuyerARR = async (data, callback) => {
  try {
    const response = await axios({
      method: "put",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}update-key-buyer-report-email-frequency`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const interestedForDonation = async (data, callback) => {
  try {
    const response = await axios({
      method: "put",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}report/arr/interestedToLearn`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const savePartsrfqrequest = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      data,
      headers,
      url: `${process.env.GATSBY_API_URL}aviation/genericPart/rfqRequest`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getNCNDAList = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}user/ncndaList`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const claimYourProfile = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      headers,
      data,
      url: `${process.env.GATSBY_API_URL}register/claim-profile`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getOtherIndustryListings = async (params, callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      params,
      url: `${process.env.GATSBY_API_URL}user/otherListingInMyIndustry`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const customerFeedback = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      headers,
      data,
      url: `${process.env.GATSBY_API_URL}user/customerFeedback`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getRedeploymentDetail = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}report/redeploymentDetail/auction`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const getRedeploymentRecipient = async (callback) => {
  try {
    const response = await axios({
      method: "get",
      headers,
      url: `${process.env.GATSBY_API_URL}report/redeploymentDetail/recipient`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};

export const pushRedeploymentDetail = async (data, callback) => {
  try {
    const response = await axios({
      method: "post",
      headers,
      data,
      url: `${process.env.GATSBY_API_URL}report/redeploymentDetail`,
    });
    callback(response);
  } catch (e) {
    callback(e);
  }
};
